<div class="filter-container">
  <div class="filter-sidebar">
    <div class="filter-header d-flex justify-content-between align-items-center">
      <h2 class="text-lg font-semibold">
        <img src="assets/icons/filterIcon.svg" alt="Icon" /> Filter by
      </h2>
      <span>
        <img
          src="assets/icons/resetIcon.svg"
          width="16"
          height="16"
          [class]="'img-fluid ms-2 ' + (canReset ? 'pointer' : 'disabled')"
          alt="Reset"
          [style.opacity]="canReset ? '1' : '0.5'"
          [style.cursor]="canReset ? 'pointer' : 'not-allowed'"
          (click)="canReset ? clearFilters() : null"
          matTooltip="Reset Filters"
          matTooltipPosition="above"
        />
      </span>
    </div>
    <div class="filter-sections">
      <app-filter-accordion
        *ngFor="let filter of filters"
        [config]="filter"
        (filterChange)="onFilterChange($event)"
      ></app-filter-accordion>
    </div>

    <!-- Apply Button -->
    <div class="filter-actions bottom-0 bg-white" style="position: sticky; z-index: 999">
      <!-- [disabled]="!hasSelectedFilters" -->
      <button
        class="btn button-primary apply-btn d-flex justify-content-center align-items-center ms-auto"
        (click)="applyFilters()"
      >
        Apply
      </button>
    </div>
  </div>
</div>
